'use client'

import { createContext, ReactNode, RefObject, useMemo, useRef } from 'react'
import { keyBy } from 'lodash'

import { AbTestDto } from '@marketplace-web/shared/ab-tests-data'

type AbTestsProviderProps = {
  children: ReactNode
  initialAbTests: Array<AbTestDto>
}

type AbTests = Record<string, AbTestDto>

export const AbTestsContext = createContext<{
  abTests: AbTests
  loggedAbTestsRef: RefObject<Array<string>>
}>({
  abTests: {},
  loggedAbTestsRef: { current: [] },
})

const AbTestsProvider = ({ initialAbTests, children }: AbTestsProviderProps) => {
  const loggedAbTestsRef = useRef<Array<string>>([])

  const abTestsObject = useMemo(
    () => ({
      abTests: keyBy(initialAbTests, abTest => abTest.name),
      loggedAbTestsRef,
    }),
    [initialAbTests],
  )

  return <AbTestsContext.Provider value={abTestsObject}>{children}</AbTestsContext.Provider>
}

export default AbTestsProvider
